
<v-content>
  <v-row class="layout" wrap>
    <v-col cols="12">
      <h1 class="display-1">
        {{ $t("TERMS_CONDITIONS_HEADER") }}
      </h1>
    </v-col>
    <v-col class="tosContent" cols="12">
      <div v-html="$t('TERMS_CONDITIONS_TEXT')"></div>
    </v-col>
  </v-row>
</v-content>

